import React, { useEffect, useRef, useState } from "react"; 
import { useLocation } from "react-router-dom";
import ChatHeader from "../ChatHeader";
import ProfileView from "../ProfileView";
import CallModal from "../CallModal";
import CallScreen from "../CallScreen";
import CallingScreen from "../CallingScreen";
// ✅ Import the new Ad component
import InterstitialAd from "../ads/InterstitialAd"; 
import { renderMessagesWithDates } from "./messageUtils";
import "../../css/chat.css";

export default function ChatBox(props) {
  const {
    user, receiverProfile, messages, history, text, typing,
    inCall, calling, incomingCall, showProfile, localStream,
    remoteStream, chatRef, setText, setShowProfile, sendMessage,
    handleTyping, startCall, acceptCall, rejectCall, endCall,
  } = props;

  const location = useLocation();
  const hasCalled = useRef(false);

  // --- ✅ NEW AD LOGIC ---
  const [showAd, setShowAd] = useState(false);
  const [wasInCall, setWasInCall] = useState(false);

  useEffect(() => {
    // 1. Detect if the user enters a call
    if (inCall || calling) {
      setWasInCall(true);
    }

    // 2. Detect when the call session ends (for both caller & receiver)
    if (wasInCall && !inCall && !calling && !incomingCall) {
      setShowAd(true);
      setWasInCall(false);
    }
  }, [inCall, calling, incomingCall, wasInCall]);
  // -----------------------

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const autoCallType = queryParams.get("call");
    if (autoCallType && !hasCalled.current) {
      if (autoCallType === "audio" || autoCallType === "video") {
        hasCalled.current = true;
        startCall(autoCallType === "audio" ? "audio" : "video");
        const newUrl = window.location.pathname;
        window.history.replaceState(null, '', newUrl);
      }
    }
  }, [location.search, startCall]);

  const safeHistory = Array.isArray(history) ? history : [];
  const safeMessages = Array.isArray(messages) ? messages : [];
  const allMessages = [...safeHistory, ...safeMessages].sort(
    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
  );

  return (
    <div className="chat-wrapper">
      {/* ✅ Add the Interstitial Ad here */}
      <InterstitialAd isOpen={showAd} onClose={() => setShowAd(false)} />

      {(calling || inCall) && (
        <div className="call-screen">
          {calling && <CallingScreen receiverName={receiverProfile?.name} onCancel={endCall} />}
          {inCall && <CallScreen localStream={localStream} remoteStream={remoteStream} onEnd={endCall} />}
        </div>
      )}

      {!calling && !inCall && (
        <div className="chat-container">
          <ChatHeader profile={receiverProfile} onAvatarClick={() => setShowProfile(true)} onCall={startCall} />
          {showProfile && (
            <ProfileView 
              userId={receiverProfile?._id || receiverProfile?.id} 
              onClose={() => setShowProfile(false)} 
            />
          )}
          {incomingCall && (
            <CallModal
              callerName={receiverProfile?.name}
              type={incomingCall.type}
              onAccept={acceptCall}
              onReject={rejectCall}
              canAccept={!inCall}
            />
          )}
          <div className="chat-messages" ref={chatRef}>
            {renderMessagesWithDates(allMessages, user?._id || user?.id)}
            {typing && <div className="typing-indicator">Typing...</div>}
          </div>
          <div className="chat-input-row">
            <input className="chat-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={handleTyping} placeholder="Type a message" />
            <button className="chat-btn" onClick={sendMessage} disabled={!text.trim()}>➤</button>
          </div>
        </div>
      )}
    </div>
  );
}